// Configuration service for managing user configuration

import { authenticatedFetch } from '../utils/apiUtils';

export type LearningMethod = 'NEW' | 'FOCUS' | 'SPACED_REPETITION';
export type OutputMode = 'DEFAULT' | 'FLASHCARD';
export type LanguageMode = 'JAPANESE' | 'ENGLISH' | 'MIXED' | 'KANJI' | 'VERBS';

export interface UserConfiguration {
  username?: string;
  vocableNumber: number;
  learningMethod: LearningMethod;
  outputMode: OutputMode;
  languageMode: LanguageMode;
  includedConjugations?: string[];
  reduceScriptSwitching?: boolean;
}

export const configService = {
  // Get user configuration from backend
  async getConfiguration(): Promise<UserConfiguration> {
    const response = await authenticatedFetch('/api/user/configuration', {
      method: 'GET',
    });

    if (!response.ok) {
      const errorMessage = await response.text();
      throw new Error(errorMessage || 'Failed to fetch configuration');
    }

    return await response.json();
  },

  // Save user configuration to backend
  async saveConfiguration(config: UserConfiguration): Promise<UserConfiguration> {
    const response = await authenticatedFetch('/api/user/configuration', {
      method: 'POST',
      body: JSON.stringify(config),
    });

    if (!response.ok) {
      const errorMessage = await response.text();
      throw new Error(errorMessage || 'Failed to save configuration');
    }

    return await response.json();
  },
};

